import { motion } from "framer-motion";
import { Truck, Sofa, HardHat, FlaskConical, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    icon: Truck,
    title: "Déménagement",
    desc: "Particuliers, entreprises, longue distance. Transport, emballage et manutention par notre équipe.",
    span: "md:col-span-7",
    image:
      "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHx0cmFuc3BvcnQlMjBkZWxpdmVyeSUyMHRydWNrJTIwcm9hZHxlbnwwfHx8fDE3ODE0MDEwMzh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Sofa,
    title: "Débarras de meubles",
    desc: "Vide-maison, succession, encombrants. Tri, évacuation et nettoyage.",
    span: "md:col-span-5",
  },
  {
    icon: HardHat,
    title: "Débarras de chantier",
    desc: "Évacuation de gravats, matériaux et déchets de chantier en toute conformité.",
    span: "md:col-span-5",
  },
  {
    icon: FlaskConical,
    title: "Produits chimiques",
    desc: "Manutention et débarras de produits dangereux ou spécifiques avec protocole adapté.",
    span: "md:col-span-7",
    accent: true,
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-white border-y border-black/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-5">02 · Services</div>
            <h2 className="font-display text-4xl md:text-6xl font-light tracking-tighter leading-[1.02]">
              Quatre interventions.<br />
              <span className="text-neutral-400">Une seule exigence.</span>
            </h2>
          </div>
          <Link
            to="/devis"
            data-testid="services-cta"
            className="text-sm font-semibold underline underline-offset-8 decoration-[#FF2800] decoration-2 hover:text-[#FF2800] transition"
          >
            Démarrer un devis →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${idx}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: idx * 0.08 }}
                className={`${s.span} group relative bg-[#FAFAFA] border border-black/10 rounded-2xl p-8 md:p-12 hover:bg-white hover:border-black/20 transition-all duration-500 overflow-hidden`}
              >
                {s.accent && (
                  <div className="absolute top-0 right-0 w-24 h-1 bg-[#FF2800]" />
                )}
                <div className="flex items-start justify-between mb-12">
                  <div className="w-12 h-12 rounded-full bg-black text-white flex items-center justify-center group-hover:bg-[#FF2800] transition-colors">
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  <ArrowUpRight className="text-neutral-300 group-hover:text-black transition" size={24} strokeWidth={1.2} />
                </div>
                <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight mb-4">{s.title}</h3>
                <p className="text-neutral-600 leading-relaxed max-w-md">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
